<template>
    <div style="">
        <!-- <img src="../assets/img/4.png" style="width:100%;min-width:700px" alt=""> -->
        <div class="shopbg">

        </div>
        <div class="shophome"  >

            <a
                target="_blank"
                href="http://www.yzparking.cn/shop/dist/index.html#/"
                class="loginsh animated fadeInDown"
                style="display:none;font-size:22px"
            >Go !</a>

        </div>

        <img
            src="../assets/img/shagnhufooter.png"
            style="width:100%;min-width:1200px"
            alt=""
        >

    </div>
</template>
<script>
export default {
  name: 'shopservice',
  data() {
    return {
      shopservice1: true,
      scrollTop: 0,
    };
  },
  methods: {},
  mounted: function() {
    // window.addEventListener(
    //   'scroll',
    //   function() {
    //     this.scrollTop =
    //       document.documentElement.scrollTop || document.body.scrollTop;
    //     if (this.scrollTop > 100) {
    //       this.shopservice1 = true;
    //     }
    //   },
    //   true
    // );
  },
};
</script>

<style scoped>
.shophome {
  width: 100%;
  height: 100vh;
  background-image: url('../assets/img/shaghu.jpg');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  justify-items: center;
}

.shopservice {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  padding-top: 100px;
  margin: 0 auto;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
}
.itemtext {
  text-align: center;
  width: 100%;
  margin-top: 200px;
}
.loginsh {
  height: 40px;
  width: 240px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  color: #fff;
   background-color: #67c23a;
  border-color: #67c23a;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  font-size: 22px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 10px 10px;
  border-radius: 25px;
  margin-top: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/shopservice.vue